<svelte:options
  customElement={{
    tag: 'dynamic-svelte-datatable',
    props: {
      columns: { type: 'Array' },
      dataset: { type: 'Array' },
      showFavouriteButton: { type: 'Boolean' },
      portal: { type: 'Object' },
      config: { type: 'Object' },
      dateRange: { type: 'Object' },
    },
    shadow: 'none',
  }}
/>

<script>
  import { DataTable, exportCSV } from 'simple-datatables';
  import { getIsFavourited, toggleChartFavourite } from '../chart/common.svelte';

  let {
    id = '',
    showFavouriteButton = false,
    portal = {},
    config = {
      title: 'Chart',
      attribution: 'Chart',
      type: 'table',
    },
    dataset = [],
    dateRange = {},

    // events
    refreshFavourites = () => {},
  } = $props();

  let isFavourited = $derived(getIsFavourited(portal, id));

  let head = $derived(Object.keys(dataset[0]));
  let body = $derived(dataset.map((row) => Object.values(row)));
  let table;

  let dataTable = $derived(null);

  const YEAR_FORMAT = /^(\d{4})$/;
  const MONTH_YEAR_FORMAT = /^([A-z]{3})-(\d{2})$/;
  const YEAR_MONTH_FORMAT = /^(\d{2})-([A-z]{3})$/;
  function getDateFormat(date) {
    if (YEAR_FORMAT.test(date)) {
      return 'YYYY';
    } else if (MONTH_YEAR_FORMAT.test(date)) {
      return 'MMM-YY';
    } else if (YEAR_MONTH_FORMAT.test(date)) {
      return 'YY-MMM';
    }
  }

  $effect(() => {
    let columns = [];

    if (config.xAxisType === 'datetime') {
      for (const row of dataset) {
        let label = row[config.labelColumn];
        if (label) {
          let format = getDateFormat(label);
          if (format) {
            columns.push({
              select: 0,
              type: 'date',
              format,
            });
          }
        }
      }
    }

    dataTable = new DataTable(table, {
      columns,
      perPageSelect: false,
      searchable: false,
      perPage: portal.rowspan === 1 ? 4 : portal.rowspan === 2 ? 14 : 10,
    });
  });
</script>

<div class="dynamic-datatable">
  <h2>{config.title}</h2>
  <div>Source: {config.attribution}</div>
  <div class="table-buttons">
    {#if showFavouriteButton}
      <button
        class="favourite-button"
        aria-label="Favourite"
        type="button"
        onclick={() =>
          (isFavourited = toggleChartFavourite(
            portal,
            id,
            dateRange,
            refreshFavourites
          ))}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="favourite-icon {isFavourited
            ? 'favourited'
            : ''} feather feather-heart"
        >
          <path
            d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
          ></path>
        </svg>
      </button>
    {/if}

    <button
      class="context-button"
      aria-label="Menu"
      type="button"
      popovertarget={'menu-' + id}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-menu"
      >
        <line x1="3" y1="12" x2="21" y2="12"></line>
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <line x1="3" y1="18" x2="21" y2="18"></line>
      </svg>
    </button>
  </div>

  <div class="context-menu" id={'menu-' + id} popover="auto">
    <ul class="context-menu__inner">
      <li class="menu-item">
        <button
          type="button"
          onclick={() => exportCSV(dataTable, { download: true })}
        >
          Download CSV
        </button>
      </li>
    </ul>
  </div>

  <table bind:this={table}>
    <thead>
      <tr>
        {#each head as column, i (i)}
          <th>{column}</th>
        {/each}
      </tr>
    </thead>
    <tbody>
      {#each body as row, i (i)}
        <tr>
          {#each row as column, j (j)}
            <td>{column}</td>
          {/each}
        </tr>
      {/each}
    </tbody>
  </table>
</div>
